<div class="fx-column align-items-center justify-content-center" *ngIf="user && user?.avatar && !error">
  <img [src]="user?.avatar" [style.width.px]="size" [style.height.px]="size" [style.border-radius.px]="size"
    (error)="error = true;" [class.shadow]="mode == 'shadow'" class="avatar-img" />
</div>
<div class="main-bg fx-column align-items-center justify-content-center" *ngIf="!user || !user?.avatar || error"
  [style.width.px]="size" [style.height.px]="size" [style.border-radius.px]="size" [class.shadow]="mode == 'shadow'">
  <span [class]="getInitialsClass()">
    {{initials}}
  </span>
</div>